import { render, staticRenderFns } from "./ValidConstitucionSociedades.vue?vue&type=template&id=17050fe6"
import script from "./ValidConstitucionSociedades.vue?vue&type=script&lang=js"
export * from "./ValidConstitucionSociedades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17050fe6')) {
      api.createRecord('17050fe6', component.options)
    } else {
      api.reload('17050fe6', component.options)
    }
    module.hot.accept("./ValidConstitucionSociedades.vue?vue&type=template&id=17050fe6", function () {
      api.rerender('17050fe6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/tasks/validaciones/ValidConstitucionSociedades.vue"
export default component.exports